import React, { useRef, useState, useEffect } from 'react';
import siteContent from '../../data/siteContent';
import SectionTitle from '../common/SectionTitle';
import "../../styles/app.css"

function FactorySection() {
  const videoRef = useRef(null);
  const progressBarRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [progress, setProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState('0:00');
  const [duration, setDuration] = useState('0:00');

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${String(s).padStart(2, '0')}`;
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const onTimeUpdate = () => {
      setProgress((video.currentTime / video.duration) * 100 || 0);
      setCurrentTime(formatTime(video.currentTime));
    };

    const onLoadedMetadata = () => {
      setDuration(formatTime(video.duration));
    };

    video.addEventListener('timeupdate', onTimeUpdate);
    video.addEventListener('loadedmetadata', onLoadedMetadata);

    return () => {
      video.removeEventListener('timeupdate', onTimeUpdate);
      video.removeEventListener('loadedmetadata', onLoadedMetadata);
    };
  }, []);

  const handleTogglePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {});
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const handleToggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !videoRef.current.muted;
    setIsMuted(videoRef.current.muted);
  };

  const handleSeek = (e) => {
    const video = videoRef.current;
    const bar = progressBarRef.current;
    if (!video || !bar) return;
    const rect = bar.getBoundingClientRect();
    const ratio = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
    video.currentTime = ratio * video.duration;
  };

  return (
    <section id="fabrica">
      <div className="container center">
        <SectionTitle
          label={siteContent.factory.label}
          title={siteContent.factory.title}
          accent={siteContent.factory.titleAccent}
          center
        />

        <p className="s-body reveal">{siteContent.factory.subtitle}</p>

        <div className="video-outer reveal">
          <div className="video-real-wrapper">
            <video
              ref={videoRef}
              className="factory-video"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            >
              <source src="/video.mp4" type="video/mp4" />
            </video>

            <div className="video-controls-bar">
              <button
                type="button"
                className="vc-btn"
                onClick={handleTogglePlay}
                aria-label={isPlaying ? 'Pausar vídeo' : 'Reproduzir vídeo'}
              >
                {isPlaying ? (
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <rect x="6" y="4" width="4" height="16" rx="1" />
                    <rect x="14" y="4" width="4" height="16" rx="1" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M8 5.14v13.72L19 12 8 5.14Z" />
                  </svg>
                )}
              </button>

              <span className="vc-time">{currentTime}</span>

              <div
                ref={progressBarRef}
                className="vc-progress"
                onClick={handleSeek}
                role="slider"
                aria-label="Progresso do vídeo"
                aria-valuenow={Math.round(progress)}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                <div
                  className="vc-progress-fill"
                  style={{ width: `${progress}%` }}
                />
              </div>

              <span className="vc-time">{duration}</span>

              <button
                type="button"
                className="vc-btn"
                onClick={handleToggleMute}
                aria-label={isMuted ? 'Ativar som' : 'Desativar som'}
              >
                {isMuted ? (
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                    <path d="M11 5 6 9H2v6h4l5 4V5Z" fill="currentColor" stroke="none" />
                    <line x1="23" y1="9" x2="17" y2="15" />
                    <line x1="17" y1="9" x2="23" y2="15" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                    <path d="M11 5 6 9H2v6h4l5 4V5Z" fill="currentColor" stroke="none" />
                    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
                    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FactorySection;